import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'kenshin';
import { CopyOutlined, CloseOutlined } from '@ant-design/icons';
import './index.less';
import {
  copytaskplanexcelsheetnew,
  saveupdatetaskplanexcelsheet,
} from '@/_serveice/task';
import AddTabModal from '../AddTabModal';

const TabsComponent = ({
  activeTab,
  onTabChange,
  onTabAdd,
  onTabDelete,
  onTabRename,
  tabs = [],
  disabled = false,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editingTabId, setEditingTabId] = useState(null);
  const [editingTabName, setEditingTabName] = useState('');
  const [addModalVisible, setAddModalVisible] = useState(false);

  const handleTabClick = (tabId) => {
    if (!isEditing) {
      onTabChange(tabId);
    }
  };

  const handleDoubleClick = (tab) => {
    if (disabled) return;
    setIsEditing(true);
    setEditingTabId(tab.id);
    setEditingTabName(tab.name);
  };

  const handleInputChange = (e) => {
    setEditingTabName(e.target.value);
  };

  const handleInputBlur = () => {
    if (editingTabId && editingTabName.trim()) {
      onTabRename(editingTabId, editingTabName.trim());
    }
    setIsEditing(false);
    setEditingTabId(null);
    setEditingTabName('');
  };

  const handleInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleInputBlur();
    }
  };

  const handleAddTab = () => {
    setAddModalVisible(true);
  };

  const handleAddModalSave = (values) => {
    const { excelSheetName, taskIdList } = values;
    const handleRes = (res) => {
      if (res.data) {
        const newTab = {
          id: res.data,
          name: excelSheetName,
          data: [],
          taskExcelSheetId: res.data,
        };
        onTabAdd(newTab);
        setAddModalVisible(false);
      }
    };
    if (taskIdList.length > 0) {
      copytaskplanexcelsheetnew(values).then(handleRes);
    } else {
      saveupdatetaskplanexcelsheet({
        excelSheetName,
      }).then(handleRes);
    }
  };

  const handleDeleteTab = (e, tabId) => {
    e.stopPropagation();
    onTabDelete(tabId);
  };

  const handleCopyTab = (e, tab) => {
    e.stopPropagation();
    const currentTab = tabs.find((t) => t.id === tab.id);
    if (currentTab) {
      const newTabName = `${currentTab.name}_复制`;
      copytaskplanexcelsheet({
        excelSheetId: currentTab.taskExcelSheetId,
        excelSheetName: newTabName,
      }).then((res) => {
        if (res.data) {
          const newTabId = res.data;
          const newTab = {
            id: newTabId,
            name: newTabName,
            data: [],
            taskExcelSheetId: res.data,
          };
          // onTabAdd(newTab);
        }
      });
    }
  };

  return (
    <div className="excel-tabs">
      <div className="tabs-container">
        {!disabled && (
          <Button type="text" className="add-tab-btn" onClick={handleAddTab}>
            +
          </Button>
        )}
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => handleTabClick(tab.id)}
            onDoubleClick={() => handleDoubleClick(tab)}
          >
            {isEditing && editingTabId === tab.id ? (
              <input
                type="text"
                value={editingTabName}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyPress={handleInputKeyPress}
                autoFocus
              />
            ) : (
              <>
                <span className="tab-name">{tab.name}</span>
                {/* {!disabled && (
                  <Tooltip title="复制">
                    <span
                      className="tab-copy"
                      onClick={(e) => handleCopyTab(e, tab)}
                    >
                      <CopyOutlined />
                    </span>
                  </Tooltip>
                )} */}
                {!disabled && (
                  <Tooltip title="删除">
                    <span
                      className="tab-close"
                      onClick={(e) => handleDeleteTab(e, tab.id)}
                    >
                      <CloseOutlined />
                    </span>
                  </Tooltip>
                )}
              </>
            )}
          </div>
        ))}
      </div>
      <AddTabModal
        visible={addModalVisible}
        onCancel={() => setAddModalVisible(false)}
        onSave={handleAddModalSave}
        tabs={tabs}
      />
    </div>
  );
};

export default TabsComponent;
